import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/omi-logo.svg'


const _hoisted_1 = { class: "mypage" }
const _hoisted_2 = { style: {"padding-bottom":"300px"} }

import { ref } from "vue";

import CommonButton from "./CommonButton.vue";
import RegistModal from "./RegistModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Withdrawn',
  setup(__props) {

const showModal = ref(false);
function onDialogAction() {
  showModal.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 再登録画面 "),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("header", { class: "header" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1 /* HOISTED */)),
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "setion01",
        style: {"height":"60px","background-color":"rgba(8, 110, 182, 0.04)"}
      }, [
        _createElementVNode("p", { style: {"margin":"0","padding-top":"18px"} }, "退会済")
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section02" }, [
          _createElementVNode("p", null, "再度ご利用になる場合は新規登録が必要です")
        ], -1 /* HOISTED */)),
        _createVNode(CommonButton, {
          data: {
          status: 0,
          button: '再登録に進む',
        },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onDialogAction()))
        })
      ])
    ]),
    _createVNode(RegistModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event))
    }, null, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})